module.exports = __webpack_public_path__ + "images/referenzen/animationsfilm/tui_oneshare_animation.jpg";